import { render, staticRenderFns } from "./RubricAdd.vue?vue&type=template&id=5aaa8971&scoped=true"
import script from "./RubricAdd.vue?vue&type=script&lang=js"
export * from "./RubricAdd.vue?vue&type=script&lang=js"
import style0 from "./RubricAdd.vue?vue&type=style&index=0&id=5aaa8971&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaa8971",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aaa8971')) {
      api.createRecord('5aaa8971', component.options)
    } else {
      api.reload('5aaa8971', component.options)
    }
    module.hot.accept("./RubricAdd.vue?vue&type=template&id=5aaa8971&scoped=true", function () {
      api.rerender('5aaa8971', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/rubricSetting/Add/RubricAdd.vue"
export default component.exports